<template>
  <div class="referral center-just">
    <div class="column">
      <!-- <el-image
        :src="$domain + 'static/noten/website/home/index1_title2_img.png'"
        style="width: 320px;height: 129px;align-self: center;cursor: pointer;"
      ></el-image> -->
      <div>
        <div class="center-just box-title" style="caret-color: transparent;">
          课程体系
        </div>
        <div class="center-just title-info" style="caret-color: transparent;">
          信息学体系全覆盖，确保学习连贯性
        </div>
      </div>
      <el-image
        :src="$domain + 'static/noten/website/home/index1_box2_img.png'"
        style="cursor: pointer;margin-top: 20px;height: 800px;width: 1400px;"
        :class="{ 'hover-scale': isHovering }"
        @mouseover="isHovering = true"
        @mouseout="isHovering = false"
      ></el-image>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isHovering: false
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.hover-scale {
  transform: scale(1.05);
  transition: transform 0.3s ease-in-out;
}

.referral {
  height: 1306px;
  background-color: #ffffff;
}

.box-title {
  height: 46px;
  font-size: 46px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #1a1a1a;
}

.title-info {
  height: 20px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  margin-top: 33px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/programming/box/box2.vue